import React, {Component} from "react";
import cn from 'classnames';
import PropTypes from 'prop-types';
import LoadingContainer from "~/components/LoadingContainer/LoadingContainer";
import css from './css.css';
import { Heading, VFlexPropagate } from "~/native-ui";

const NavigatableResultTable = ({ResultTable, ResultCalendar, Pagination, trans}) => {
    class _NavigatableResultTable extends Component {
        static propTypes = {
            isCalendarEnabled: PropTypes.bool,
            autoHidePagination: PropTypes.bool.isRequired,
            perPageTooltip: PropTypes.string,
            paginationTooltip: PropTypes.string
        };

        static defaultProps = {
            autoHidePagination : false,
        };

        get showCalendar () {
            return this.props.isCalendarEnabled && !!ResultCalendar
        }

        needsPagination = () => {
            return this.props.perPage < this.props.resultValue.total;
        };

        renderContent = () => {
            let { autoHidePagination, commonProps, trans, tooltipsActive, ...other } = this.props;
            if(!this.showCalendar && !this.props.loading && this.props.resultValue.total < 1) {
                return <Heading fontSize="lg" className={css.message}>{trans('noItems')}</Heading>
            }

            let shouldRenderPagination = !this.showCalendar && (!autoHidePagination || this.needsPagination());

            let renderElements = () => {
                const props = {
                    ...other,
                    ...commonProps,
                    needsPagination: this.needsPagination()
                }

                return this.showCalendar ? <ResultCalendar { ...props } /> : <ResultTable { ...props } />
            };

            let renderPagination = () => <Pagination
                autoHidePagination={shouldRenderPagination}
                perPageTooltip={tooltipsActive ? trans('page_navigation.tooltip') : null}
                paginationTooltip={tooltipsActive ? trans('pagination.tooltip') : null}
                className={css.paginationBar}
                {...commonProps}
            />

            return <>
                {renderElements()}
                {renderPagination()}
            </>;
        };

        render() {
            let { commonProps } = this.props;
            
            return (
                <LoadingContainer
                    loading={this.props.loading}
                    ready={true}
                    {...commonProps}
                    containerClassName={cn(commonProps.containerClassName, css.dataTableContainer)}
                >
                    <VFlexPropagate>
                        {this.renderContent()}
                    </VFlexPropagate>
                </LoadingContainer>
            );
        }
    }

    return _NavigatableResultTable;
};

export default NavigatableResultTable;